import React from "react";
import { motion, MotionConfig } from "motion/react";

const initialY = '-110%';

const slideDown = {
	animate: {
		y: 0,
		opacity: 1,
		transition: {
			ease: 'easeOut',
		},
	},
	exit: {
		y: initialY,
		opacity: 0,
		transition: {
			ease: 'easeIn',

		}
	}
}

const DropdownWrapper = ({ menuID, openMenuID, children }) => {
	const isOpen = menuID === openMenuID;

	const headerHeight = document.querySelector('.header__nav').offsetHeight;
	
	return (
		<MotionConfig reducedMotion="user">
			<div className="dropdown">
				<div className={`dropdown__mask-container ${isOpen ? 'is-open' : ''}`}>
					<motion.div
						key={menuID}
						initial={false}
						animate={isOpen ? "animate" : "exit"}
						exit="exit"
						variants={slideDown}
						className="dropdown__grid">
						<div className="dropdown__content"

							// disable tabbing through children when menu is closed
							{...{ inert: !isOpen ? '' : undefined }}
						>
							{children}
						</div>
					</motion.div>
				</div>
			</div>
		</MotionConfig>
	)
};


export default DropdownWrapper;
